import { VStack, HStack, Box, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router';
import { CustomArrowRightIcon } from '../../../theme/icons/CustomArrowRightIcon';
import { useMfa } from '../../../context/MfaContext';
import { useMfaApi } from '../../../hooks/useMfaApi';
import { useMfaToast } from '../../../hooks/useMfaToast';

function MfaSetUp({ onMethodSelect, isModal = false, otpMethod = null }) {
  const { startMfaSetup } = useMfa();
  const navigate = useNavigate();
  const { setupMfa } = useMfaApi();
  const { showErrorToast } = useMfaToast();

  const handleSetup = async (type) => {
    if (onMethodSelect) {
      onMethodSelect(type);
      return;
    }

    try {
      const data = await setupMfa(type);
      startMfaSetup(type, data.otp_uri, data.otp_secret);
      navigate(`/mfa/setup/${type}`);
    } catch (error) {
      showErrorToast(
        'Error setting up MFA',
        error.response?.data || 'Failed to setup MFA. Please try again.'
      );
    }
  };

  return (
    <VStack spacing={6} alignItems="flex-start" w="full">
      {!isModal && (
        <VStack alignItems="flex-start" mb={4}>
          <Text textStyle="heading2">Two-Step Verification</Text>
          <Text pl={2} textStyle="bodySmall" color="#666666">
            Add an extra layer of security to your account by enabling two-step
            verification.
            <br />
            Choose one of the options below.
          </Text>
        </VStack>
      )}
      <VStack spacing={6} mb={4} alignItems="flex-start">
        <Box
          opacity={otpMethod === 'totp' ? 0.5 : 1}
          cursor={otpMethod === 'totp' ? 'not-allowed' : 'default'}
        >
          <HStack
            gap={4}
            onClick={
              otpMethod === 'totp' ? undefined : () => handleSetup('totp')
            }
            cursor={otpMethod === 'totp' ? 'not-allowed' : 'pointer'}
            opacity={otpMethod === 'totp' ? 0.5 : 1}
          >
            <Text
              textStyle="heading4"
              color={otpMethod === 'totp' ? '#999999' : 'inherit'}
            >
              Authentication app
            </Text>
            <CustomArrowRightIcon
              color={otpMethod === 'totp' ? '#999999' : 'brand'}
            />
          </HStack>
          <Text
            textStyle="bodySmall"
            color={otpMethod === 'totp' ? '#999999' : '#666666'}
          >
            Scan a QR code to pair your device and generate secure login codes.
            <br />
            This method is recommended for maximum security.
          </Text>
        </Box>
        <Box
          opacity={otpMethod === 'email' ? 0.5 : 1}
          cursor={otpMethod === 'email' ? 'not-allowed' : 'default'}
        >
          <HStack
            gap={4}
            onClick={
              otpMethod === 'email' ? undefined : () => handleSetup('email')
            }
            cursor={otpMethod === 'email' ? 'not-allowed' : 'pointer'}
            opacity={otpMethod === 'email' ? 0.5 : 1}
          >
            <Text
              textStyle="heading4"
              color={otpMethod === 'email' ? '#999999' : 'inherit'}
            >
              E-mail code
            </Text>
            <CustomArrowRightIcon
              color={otpMethod === 'email' ? '#999999' : 'brand'}
            />
          </HStack>
          <Text
            textStyle="bodySmall"
            color={otpMethod === 'email' ? '#999999' : '#666666'}
          >
            Get a one-time code sent to your registered email each time you log
            in.
          </Text>
        </Box>
      </VStack>
      {!isModal && (
        <Text
          textStyle="bodySmall"
          color="brand"
          onClick={() => navigate('/dashboard')}
          cursor="pointer"
          _hover={{
            textDecoration: 'underline',
          }}
        >
          Skip for now
        </Text>
      )}
    </VStack>
  );
}

export default MfaSetUp;
